<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-09 15:46:06
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Event\EventList\EventList.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-21 10:39:17
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_event_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-event-management')"
    @new="toNew"
    @activated="activated"
    :exportBtn="hasBtn('export-admin-event-management')"
    :importBtn="hasBtn('import-admin-event-management')"
    :import-options="{
      api: '/event/import/',
      templateUrl:
        ' https://assets.essencehr.io/web/ess-business/assets/event-import-template.xlsx',
      success: (result) => {
        getEventTypeList();
      },
    }"
    @export="onExport"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        :curkey="curkey"
        closeTranslate
        @filter="
          (val, tab) => {
            if (tab == 1) {
              filterPageData1 = val;
            } else filterPageData2 = val;
          }
        "
        contentBackground="transparent pa-0"
      >
        <!-- 筛选 -->
        <template v-slot:filter-content-1="{ filter }">
          <div v-show="curTab === 'tab-1'">
            <Selections2
              :objects="filterObjects"
              small-chip
              @filter="
                filter();
                toFilter(1, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects, null, null);
                  if (apply) {
                    filter();
                    toFilter(1, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-2="{ filter }">
          <div v-show="curTab === 'tab-2'">
            <Selections2
              :objects="filterObjects2"
              small-chip
              @filter="
                filter();
                toFilter(2, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects2, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects2, null, null);
                  if (apply) {
                    filter();
                    toFilter(2, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template v-slot:filter-content-3="{ filter }">
          <div v-show="curTab === 'tab-3'">
            <Selections2
              :objects="filterObjects3"
              small-chip
              @filter="
                filter();
                toFilter(3, filter);
              "
              @update="
                (prop, value, selected) => {
                  $fliterValue(filterObjects3, prop, value, selected);
                }
              "
              @reset="
                (apply) => {
                  $fliterValue(filterObjects3, null, null);
                  if (apply) {
                    filter();
                    toFilter(3, filter);
                  }
                }
              "
            />
          </div>
        </template>
        <template
          v-for="(it, index) in EventTypeList"
          :slot="`content-${index + 1}`"
        >
          <Tabler
            v-if="desserts[it.event_type_code]"
            :key="`table--${index}`"
            :filter-page-data="
              index == 0
                ? filterPageData1
                : index == 1
                ? filterPageData2
                : filterPageData3
            "
            :headers="headers"
            :items="desserts[it.event_type_code]['desserts']"
            :height="$vuetify.breakpoint.height - 335"
            :showSelect="showSelect"
            :totalCount="desserts[it.event_type_code]['totalCount']"
            @change="
              (page, perpage, callback, data) => {
                getList(
                  index + 1,
                  data,
                  it.table_name,
                  it.uuid,
                  it.event_type_code,
                  page,
                  perpage,
                  callback
                );
              }
            "
          >
            <template v-slot:item.name="{ item }">
              <div
                class="text--primary table-title"
                :title="$getCommonLangValue(item.event_business_name)"
              >
                {{ $getCommonLangValue(item.event_business_name) }}
              </div>
            </template>
            <!-- <template v-slot:item.type="{ item }">
              <div class="text--primary">
                {{ $getCommonLangValue(item.event_type_name) }}
              </div>
            </template> -->
            <template v-slot:item.total="{ item }"
              >{{ item.total_minutes
              }}{{ $t("label_essweb_system_minutesLabel") }}</template
            >
            <template v-slot:item.start="{ item }">{{
              $timeMachine(item.start_utc_time)
            }}</template>
            <template v-slot:item.end="{ item }">{{
              $timeMachine(item.end_utc_time)
            }}</template>

            <template v-slot:item.action="{ item }">
              <tableListTools
                :uuid="item.uuid"
                :table="item.table_name"
                :delBtn="hasBtn('delete-admin-event-management')"
                :viewBtn="hasBtn('view-admin-event-management')"
                :editBtn="hasBtn('edit-admin-event-management')"
                :isUuid="false"
                :title="$t('label_essweb_event_list_title')"
                @delete="toDelete(item.uuid, it.table_name, it.event_type_code)"
                @edit="toEdit(item, 'edit')"
                @view="toEdit(item, 'view')"
              />
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Event",
  computed: {
    ...mapGetters(["companyLang"]),
    taber() {
      const that = this;
      let arr = [];
      this.EventTypeList.map((item) => {
        arr.push(that.$getCommonLangValue(item.event_type_name));
      });
      return arr;
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getEventTypeList();
  },
  data() {
    return {
      search: "",
      selected: [],
      curkey: 123,
      // taber: [
      //   "label_essweb_event_list_tab_dutyLabel",
      //   "label_essweb_event_list_tab_mealLabel",
      //   "label_essweb_event_list_tab_breakLabel",
      // ],
      curTab: "tab-1",
      showAllDelete: false,
      showDelete: false,
      showSelect: false,
      headers: [
        {
          text: "label_essweb_event_list_eventNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.event_business_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1 ||
              item.event_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        // {
        //   text: "label_essweb_event_list_eventTypeLabel",
        //   align: "start",
        //   sortable: false,
        //   value: "type",
        // },
        {
          text: "label_essweb_event_list_startTimeLabel",
          value: "start",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_endTimeLabel",
          value: "end",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_totalMinutesLabel",
          value: "total",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      EventTypeList: [],
      desserts: {},
      click: 0,
      filterPageData1: null,
      filterPageData2: null,
      filterPageData3: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_event_list_eventNameLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterObjects2: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_event_list_eventNameLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterObjects3: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_event_list_eventNameLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      first: false,
    };
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        this.$fliterValue(this.filterObjects2, null, null);
        // if (this.page !== null) {
        this.desserts1 = [];
        this.desserts2 = [];
        this.curTab = "tab-1";
        let curTable1 = that.EventTypeList[0];
        let curTable2 = that.EventTypeList[1];
        let curTable3 = that.EventTypeList[2];

        this.getList(
          1,
          null,
          curTable1.table_name,
          curTable1.uuid,
          curTable1.event_type_code,
          1,
          this.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
        this.getList(
          2,
          null,
          curTable2.table_name,
          curTable2.uuid,
          curTable2.event_type_code,
          1,
          this.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
        this.getList(
          3,
          null,
          curTable3.table_name,
          curTable3.uuid,
          curTable3.event_type_code,
          1,
          this.$tableSetting.perPageSize,
          () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          }
        );
        this.first = true;
      }
      if (refresh == 1) {
        this.curTab = "tab-1";
        if (
          this.filterPageData1 ||
          this.filterPageData2 ||
          this.filterPageData3
        ) {
          let page1 = 1,
            page2 = 1,
            page3 = 1,
            pagesize1 = null,
            pagesize2 = null,
            pagesize3 = null;
          if (this.filterPageData1 && this.filterPageData1["data"]) {
            page1 = this.filterPageData1["data"]["cpage"]
              ? this.filterPageData1["data"]["cpage"]
              : 1;
            pagesize1 = this.filterPageData1["data"]["pagesize"]
              ? this.filterPageData1["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData2 && this.filterPageData2["data"]) {
            page2 = this.filterPageData2["data"]["cpage"]
              ? this.filterPageData2["data"]["cpage"]
              : 1;
            pagesize2 = this.filterPageData2["data"]["pagesize"]
              ? this.filterPageData2["data"]["pagesize"]
              : null;
          }
          if (this.filterPageData3 && this.filterPageData3["data"]) {
            page3 = this.filterPageData3["data"]["cpage"]
              ? this.filterPageData3["data"]["cpage"]
              : 1;
            pagesize3 = this.filterPageData3["data"]["pagesize"]
              ? this.filterPageData3["data"]["pagesize"]
              : null;
          }
          this.toFilter(1, () => {}, page1, pagesize1);
          this.toFilter(2, () => {}, page2, pagesize2);
          this.toFilter(3, () => {}, page3, pagesize3);
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(2, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
          this.toFilter(3, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    getEventTypeList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-list/",
      }).then((res) => {
        res.data.map((item, index) => {
          // that.desserts[item.event_type_code] = {
          //   desserts: [],
          //   key: Math.random() * 10000000000,
          //   totalCount: 0,
          // };
          that.getList(
            index + 1,
            null,
            item.table_name,
            item.uuid,
            item.event_type_code,
            1,
            that.$tableSetting.perPageSize,
            () => {
              that.$store.dispatch("resetTable", new Date().getTime());
            }
          );
        });
        that.EventTypeList = res.data;
      });
    },
    toNew: function () {
      this.$toPage("/admin/event-management/add", {});
    },
    toDelete: function (id, table, code) {
      this.showDelete = false;
      const that = this;
      this.$Request({
        method: "POST",
        table: table,
        url: "/event/delete-event-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_event_list_deleteEventSuccessLabel"),
          type: "success",
        });
        that.desserts[code]["desserts"] = that.desserts[code][
          "desserts"
        ].filter((ele) => ele.uuid !== id);
        that.curkey = Math.random() * 10000000000;
      });
    },
    toEdit: function (item, action) {
      if (action == "edit")
        this.$toPage(
          "/admin/event-management/edit/" +
            this.$aesEncrypt(
              JSON.stringify({
                id: item.uuid,
                table: item.table_name,
              })
            )
        );
      if (action == "view")
        this.$toPage(
          "/admin/event-management/detail/" +
            this.$aesEncrypt(
              JSON.stringify({
                id: item.uuid,
                table: item.table_name,
              })
            )
        );
    },
    toFilter(tab, callback, page, pagesize) {
      const that = this;
      let object = [];
      if (tab == 1) {
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else if (tab == 2) {
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else {
        object = this.filterObjects3.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      }

      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["event_business_name"] = item.value;
        }
      });
      let curTable = that.EventTypeList[tab - 1];
      if (!page) {
        this.getList(
          tab,
          data,
          curTable.table_name,
          curTable.uuid,
          curTable.event_type_code,
          1,
          this.$tableSetting.perPageSize,
          callback
        );
      } else {
        this.getList(
          tab,
          data,
          curTable.table_name,
          curTable.uuid,
          curTable.event_type_code,
          page ? page : 1,
          pagesize ? pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onExport() {
      const that = this;
      let object = [];
      let tab = 1;
      switch (this.curTab) {
        case "tab-1":
          tab = 1;
          break;
        case "tab-2":
          tab = 2;
          break;
        case "tab-3":
          tab = 3;
          break;
        default:
          break;
      }
      if (tab == 1) {
        object = this.filterObjects.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else if (tab == 2) {
        object = this.filterObjects2.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      } else {
        object = this.filterObjects3.filter((ele) =>
          Object.prototype.toString.call(ele["value"]).toLowerCase() ===
          "[object array]"
            ? ele["value"].length
            : ele.value !== undefined && ele.value != ""
        );
      }
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["event_business_name"] = item.value;
        }
      });
      let curTable = that.EventTypeList[tab - 1];
      data = Object.assign(data, { event_type_uuid: curTable.uuid });
      this.$Request({
        method: "POST",
        table: curTable.table_name,
        url: "/event/export/",
        data: data,
        type: "export",
        export_title: this.$getCommonLangValue(curTable.event_type_name) + "_",
      });
    },
    getList: function (tab, data, table, type, code, page, perpage, callback) {
      const that = this;
      this.click++;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
        data["event_type_uuid"] = type;
      }
      this.$Request({
        method: "POST",
        table: table,
        url: "/event/get-event-list/",
        data: data
          ? data
          : {
              event_type_uuid: type,
              cpage: page,
              pagesize: perpage,
            },
      }).then((res) => {
        if (!that.desserts[code]) {
          that.desserts[code] = {
            desserts: [],
            key: Math.random() * 10000000000,
            totalCount: 0,
          };
        }
        that.desserts[code]["desserts"] = res.data;
        that.curkey = Math.random() * 10000000000;
        that.desserts[code]["totalCount"] = res.totalcount;
        callback ? callback(page, perpage, data, tab) : null;
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
